package pl.decks.chartjs.radar.builder

import pl.decks.chartjs.mode.InteractionMode
import pl.decks.chartjs.radar.options.InteractionOptions

@RadarDsl
class InteractionScope {
    var mode: InteractionMode = InteractionMode.Nearest
    var intersect: Boolean = true

    internal fun build() = InteractionOptions(
        mode = mode,
        intersect = intersect,
    )
}
